/* Werkt de bezorgdag bij nadat de pagina geladen is.

   Liquid heeft het woord al ingevuld met de klok van de winkel. Dat klopt op
   het moment van renderen, maar een pagina kan uit de cache komen — en dan
   staat er om 16:05 nog "morgen" terwijl het inmiddels overmorgen is. Dit
   script rekent hetzelfde sommetje opnieuw uit en corrigeert alleen als de
   uitkomst afwijkt.

   De klok van de bezoeker doet niet mee: de afkaptijd gaat over wanneer het
   magazijn in Nederland sluit, dus er wordt expliciet in Europe/Amsterdam
   gerekend. Iemand die vanuit Spanje bestelt krijgt dezelfde dag te zien als
   iemand in Vlissingen, en dat is de juiste dag.

   Zonder dit script blijft de Liquid-uitkomst staan. Die is bijna altijd goed;
   dit is de correctie op het randgeval, niet de bron. */

(function () {
  'use strict';

  var vakjes = document.querySelectorAll('[data-bezorgdag]');
  if (!vakjes.length) return;

  var t = window.ncBezorging;
  if (!t || !t.dagen || !t.dagen.length) return;

  var afkap = typeof t.afkap === 'number' ? t.afkap : 16;

  /* Weekdag en uur in Amsterdam. Intl doet de zomertijd; zelf rekenen met een
     vaste offset gaat twee keer per jaar mis. */
  function nu() {
    try {
      var delen = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Amsterdam',
        weekday: 'short',
        hour: '2-digit',
        hour12: false
      }).formatToParts(new Date());

      var uit = {};
      delen.forEach(function (deel) { uit[deel.type] = deel.value; });

      var kaart = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      var dag = kaart[uit.weekday];
      var uur = parseInt(uit.hour, 10);
      if (dag === undefined || isNaN(uur)) return null;
      return { dag: dag, uur: uur === 24 ? 0 : uur };
    } catch (e) {
      return null; // oude browser zonder tijdzones: laat staan wat er staat
    }
  }

  var klok = nu();
  if (!klok) return;

  // Dezelfde regels als in snippets/bezorgdag.liquid.
  var verzend = 0;
  if (klok.dag === 0 || klok.dag === 6 || klok.uur >= afkap) {
    verzend = 1;
    for (var i = 0; i < 7; i++) {
      var d = (klok.dag + verzend) % 7;
      if (d !== 0 && d !== 6) break;
      verzend++;
    }
  }

  var bezorg = verzend + 1;
  if ((klok.dag + bezorg) % 7 === 0) bezorg++;

  // Zaterdag krijgt altijd zijn naam, ook als het morgen is.
  var bezorgdag = (klok.dag + bezorg) % 7;
  var woord = bezorg === 1 && bezorgdag !== 6 ? t.morgen : t.dagen[bezorgdag];
  if (!woord) return;

  vakjes.forEach(function (vak) {
    if (vak.textContent.trim() !== woord) vak.textContent = woord;
  });
})();
